import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import ManageExternalFileControl from '../manageExternalFileControl/manageExternalFileControl.vue'

export default {
  data: () => ({
    errorMessage: '',
    dialog: false,
    editDialog: false,
    deleteDialog: false,
    deleteManyDialog: false,
    buttonDeleteVisible: false,
    dialogKey: false,
    loading: false,
    error: false,
    expanded: [],
    externalFilesSelected: [],
    externalFiles: [],
    currentExternalFile: {},
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    apiService: new ApiService(),
    paginate: {
      page: 1,
      pageSize: 10,
    },
    headers: [
      {
        text: 'Nome',
        align: 'center',
        value: 'name',
        sortable: false,
      },
      {
        text: 'Vencimento',
        align: 'center',
        value: 'expired',
      },
      {
        text: 'Descrição',
        align: 'center',
        value: 'description',
        sortable: false,
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
      },
    ],
    headersMobile: [
      {
        text: 'Name',
        align: 'center',

        value: 'name',
      },
      {
        text: 'Ações',

        value: 'actions',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
  }),

  async created() {
    this.updateTable()
  },

  components: {
    ManageExternalFileControl,
  },

  methods: {
    addExternalFile() {
      this.dialogKey = !this.dialogKey
      this.dialog = true
    },

    editExternalFile(file) {
      this.currentExternalFile = file
      this.dialogKey = !this.dialogKey
      this.editDialog = true
    },

    deleteExternalFile(file) {
      this.currentExternalFile = file
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    deleteManyExternalFile() {
      this.dialogKey = !this.dialogKey
      this.deleteManyDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false

      this.updateTable()
    },

    openLink(file) {
      window.open(file.url, '_blank')
    },

    formatDate(date) {
      if (date) {
        return Utils.dateTime(date)
      }
    },

    async updateTable() {
      this.loading = true

      await this.apiService
        .post('externalFileControl/list', this.paginate)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.externalFiles = response.content.externalFileControls
          this.loading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async remove() {
      this.loading = true

      await this.apiService
        .delete('externalFileControl/delete', this.currentExternalFile)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.deleteDialog = false
    },

    async removeMany() {
      this.loading = true

      await this.apiService
        .delete('externalFileControl/deleteMany', this.externalFilesSelected)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
      this.deleteManyDialog = false
      this.buttonDeleteVisible = false
      this.externalFilesSelected = []
    },
  },

  watch: {
    pageSize() {
      this.paginate.pageSize = this.pageSize
      this.paginate.page = 1
      this.updateTable()
    },

    page() {
      this.paginate.page = this.page
      this.updateTable()
    },

    externalFilesSelected() {
      this.buttonDeleteVisible = this.externalFilesSelected.length > 0
    },
  },
}
